import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyC71yHZWds1hlgrY9pic9se8tJ-im9CNIA",
    authDomain: "makesensify-2.firebaseapp.com",
    databaseURL: "https://makesensify-2.firebaseio.com",
    projectId: "makesensify-2",
    storageBucket: "makesensify-2.appspot.com",
    messagingSenderId: "1020851774548"
};

firebase.initializeApp(config);

const database = firebase.database();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export { firebase, googleAuthProvider, database as default };